if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        this.disconnectMediaObserver();
        this.pauseMedia();
      }

      // Portée limitée à la modale : la vidéo de la galerie, elle, poursuit sa boucle.
      pauseMedia(scope = this) {
        scope.querySelectorAll('video').forEach((video) => video.pause());
        scope.querySelectorAll('.js-youtube').forEach((iframe) => {
          iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        });
        scope.querySelectorAll('.js-vimeo').forEach((iframe) => {
          iframe.contentWindow.postMessage('{"method":"pause"}', '*');
        });
        scope.querySelectorAll('product-model').forEach((model) => {
          if (model.modelViewerUI) model.modelViewerUI.pause();
        });
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.observeMedia();
      }

      // Le zoom empile les médias : chaque vidéo se lance en entrant dans la bande centrale de
      // l'écran. Observateur recréé à chaque ouverture pour relancer le média déjà visible.
      observeMedia() {
        this.disconnectMediaObserver();
        this.mediaObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) {
                this.pauseMedia(entry.target);
                return;
              }
              entry.target.loadContent(false);
              const video = entry.target.querySelector('video');
              // Lecture refusée (iOS en économie d'énergie) : le poster prend le relais.
              if (video) video.play().catch(() => {});
            });
          },
          { root: this.querySelector('[role="document"]'), rootMargin: '-25% 0px', threshold: 0 },
        );
        this.querySelectorAll('deferred-media').forEach((media) => this.mediaObserver.observe(media));
      }

      disconnectMediaObserver() {
        if (!this.mediaObserver) return;
        this.mediaObserver.disconnect();
        this.mediaObserver = null;
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
      }
    }
  );
}
